import React, { useEffect, useRef, useState } from 'react';

const PhoneCopyToast = () => {
    const [visible, setVisible] = useState(false);
    const timeoutRef = useRef(null);

    useEffect(() => {
        const handlePhoneCopied = () => {
            setVisible(true);
            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => setVisible(false), 2200);
        };

        window.addEventListener('phone-copied', handlePhoneCopied);

        return () => {
            window.removeEventListener('phone-copied', handlePhoneCopied);
            clearTimeout(timeoutRef.current);
        };
    }, []);

    if (!visible) return null;

    return (
        <div className="phone-copy-toast" role="status" aria-live="polite">
            Номер телефону скопійовано
        </div>
    );
};

export default PhoneCopyToast;
